import * as React from "react";

const SearchIconSvg = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M19.4983 19.4983L15.8623 15.8623M15.8623 15.8623C19.3747 12.3499 19.3747 6.64668 15.8623 3.13429C12.3499 -0.378097 6.64668 -0.378097 3.13429 3.13429C-0.378097 6.64668 -0.378097 12.3499 3.13429 15.8623C6.64668 19.3747 12.3499 19.3747 15.8623 15.8623Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

export default SearchIconSvg;
